export default function LevelIcon({ fill = "#9B9B9B" }) {
  return (
    <svg
      width="15"
      height="25"
      viewBox="0 0 15 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.853027" y="16.9424" width="2.45446" height="7.36337" />
      <rect x="6.23291" y="8.96558" width="2.45446" height="15.3404" />
      <rect x="11.6133" y="0.988525" width="2.45446" height="23.3173" />
    </svg>
  );
}
